import Alpine from 'alpinejs'

const data = (params = {}) => ({
  /**
   * Data
   */
  length: 12,
  hide: true,

  /**
   * Main
   */
  generateSecurePassword() {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    const digits = '0123456789'
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?'
    const allChars = letters + digits + symbols

    const getRandom = (set) => set[Math.floor(Math.random() * set.length)]

    let passwordChars = [
      getRandom(letters),
      getRandom(digits),
      getRandom(symbols)
    ]

    for (let i = 3; i < this.length; i++) {
      passwordChars.push(getRandom(allChars))
    }

    // Fisher–Yates shuffle
    for (let i = passwordChars.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[passwordChars[i], passwordChars[j]] = [passwordChars[j], passwordChars[i]]
    }

    this.$refs.password.value = passwordChars.join('')
  },

  ...params
})

Alpine.data('PasswordGenerator', data)
export default data
